export default __webpack_public_path__ + "static/media/feather_bell.17f0d5eb.svg";